import React from "react";
import {withNamespaces} from "react-i18next";

const FreeAddonComponent = (props) => {
  const {t} = props;
  const freeAddonData = props.data.free_addon || {};

  const changeData = (key, value) => {
    props.setData({free_addon: {...freeAddonData, [key]: value}});
  }

  return (
    <div className="cancellation-offer-component">
      <p className="light">
        <span className='block'>{t('member_cancellation_free_addon_description')}</span>
        <span className='block'>{t('member_cancellation_free_addon_description_line2')}</span>
      </p>
      <h3 className='mb-8'>{t('member_cancellation_free_addon_header')}</h3>

      <div>
        <p className='light'>{t('member_cancellation_free_addon_line1')}</p>
        <p className='light'>{t('member_cancellation_free_addon_line2')}</p>
        <p className='light'>{t('member_cancellation_free_addon_line3')}</p>
      </div>

      <div className="form-group terms">
        <div className="checkbox">
          <input
            id={`accept_terms`}
            name={`accept_terms`}
            type="checkbox"
            checked={freeAddonData.terms_accepted}
            onChange={() => {
              changeData('terms_accepted', !freeAddonData.terms_accepted)
            }}/>
          <label htmlFor={`accept_terms`}>
            <div dangerouslySetInnerHTML={{
              __html: props.t(`membership_cancellation_cancellation_offer_terms`)
            }}/>
          </label>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(FreeAddonComponent);